"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebContractGetProductAutocompleteResponseSchema = exports.WebContractListProductFilterOptionsResponseSchema = exports.WebContractListProductsResponseSchema = exports.WebContractGetProductResponseSchema = exports.WebContractProductSlugPathParamsSchema = exports.WebContractListProductsQueryParamsSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../../../shared");
const schema_builder_1 = require("../../../shared/schema-builder");
const ProductDiscountSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    startDate: zod_1.z.coerce.date(),
    endDate: zod_1.z.coerce.date(),
    discountPrice: zod_1.z.number(),
    discountPriceUsd: zod_1.z.number(),
    productId: zod_1.z.string(),
});
const ProductSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    collectionId: zod_1.z.string(),
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
    deletedAt: zod_1.z.coerce.date().nullable(),
    restockedAt: zod_1.z.coerce.date().nullable(),
    name: zod_1.z.string(),
    slug: zod_1.z.string(),
    skuNo: zod_1.z.string(),
    coverImage: zod_1.z.string(),
    images: zod_1.z.string().array(),
    description: zod_1.z.record(zod_1.z.string(), zod_1.z.string()).nullable(),
    price: zod_1.z.number(),
    priceUsd: zod_1.z.number(),
    stock: zod_1.z.number().int(),
    isAvailable: zod_1.z.boolean(),
    frameShape: zod_1.z.string().nullable(),
    frameColor: zod_1.z.string().nullable(),
    lensColor: zod_1.z.string().nullable(),
    isPolarized: zod_1.z.boolean(),
});
const ProductReviewSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    productId: zod_1.z.string(),
    totalReview: zod_1.z.number().int(),
    totalRating: zod_1.z.number(),
    oneStarCount: zod_1.z.number().int(),
    twoStarCount: zod_1.z.number().int(),
    threeStarCount: zod_1.z.number().int(),
    fourStarCount: zod_1.z.number().int(),
    fiveStarCount: zod_1.z.number().int(),
});
exports.WebContractListProductsQueryParamsSchema = shared_1.ContractPaginationQueryParamsSchema.extend({
    collectionId: shared_1.UUIDSchema.optional(),
    sortBy: zod_1.z.string().default('name|asc'),
    frameColor: zod_1.z.string().optional(),
    frameShape: zod_1.z.string().optional(),
    lensColor: zod_1.z.string().optional(),
    isPolarized: shared_1.BooleanQueryParamSchema,
    onlyDiscount: shared_1.BooleanQueryParamSchema,
});
exports.WebContractProductSlugPathParamsSchema = zod_1.z.object({ productSlug: zod_1.z.string() });
const ContractDiscountSchema = new schema_builder_1.SchemaBuilder(ProductDiscountSchema)
    .replaceDateField('startDate')
    .replaceDateField('endDate')
    .build();
const WebContractProductSchema = new schema_builder_1.SchemaBuilder(ProductSchema)
    .replaceDateField('createdAt')
    .replaceDateField('updatedAt')
    .replaceDateField('deletedAt', zod_1.z.string().datetime().nullable())
    .replaceDateField('restockedAt', zod_1.z.string().datetime().nullable())
    .extend({
    collectionName: zod_1.z.string(),
    collectionSlug: zod_1.z.string(),
    discount: ContractDiscountSchema.nullable(),
    productReviewSummary: ProductReviewSummarySchema.omit({
        id: true,
        productId: true,
    }).default({
        totalRating: 0,
        totalReview: 0,
        oneStarCount: 0,
        twoStarCount: 0,
        threeStarCount: 0,
        fourStarCount: 0,
        fiveStarCount: 0,
    }),
})
    .build();
exports.WebContractGetProductResponseSchema = zod_1.z.object({ product: WebContractProductSchema });
exports.WebContractListProductsResponseSchema = shared_1.ContractBaseListResponseSchema
    .extend({ products: WebContractProductSchema.array() });
exports.WebContractListProductFilterOptionsResponseSchema = zod_1.z.object({
    filters: zod_1.z.object({
        frameColors: zod_1.z.string().array(),
        frameShapes: zod_1.z.string().array(),
        lensColors: zod_1.z.string().array(),
    }),
});
exports.WebContractGetProductAutocompleteResponseSchema = zod_1.z.object({
    suggestions: zod_1.z.object({
        product: zod_1.z.object({
            name: zod_1.z.string(),
            slug: zod_1.z.string(),
            description: zod_1.z.object({
                en: zod_1.z.string(),
                th: zod_1.z.string(),
            }),
            collection: zod_1.z.object({
                slug: zod_1.z.string(),
                name: zod_1.z.string(),
            }),
        }),
    }).array(),
});
